var map = {
	"./dr-1.png": "tLZk",
	"./dr-10.png": "DxNR",
	"./dr-11.png": "zeM5",
	"./dr-2.png": "nW6X",
	"./dr-3.png": "gKdd",
	"./dr-4.png": "SdtI",
	"./dr-5.png": "X/bs",
	"./dr-6.png": "bRPO",
	"./dr-7.png": "H9iA",
	"./dr-8.png": "0Mg3",
	"./dr-9.png": "k9NU"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "oQ6Q";


//////////////////
// WEBPACK FOOTER
// ./src/products ^\.\/dr\-.*\.png$
// module id = oQ6Q
// module chunks = 0